import { ReactElement } from 'react';
import { Datasets, makeDatasetsContext } from '../../modules/datasets/datasets.context';
import { DatasetsRoute } from '../../routes/datasets/datasets.route';

export const DatasetsView = (): ReactElement => (
  <Datasets.Provider value={makeDatasetsContext()}>
    <DatasetsRoute />
  </Datasets.Provider>
);
